module.exports = __webpack_public_path__ + "img/WORLD HEARING DAY.31f3430.svg";